// ===== EDUCATION / SPORTS / OTHERS =====
const SPORTS_EDU = [
  {
    id: "bped",
    name: "B.P.Ed – Bachelor of Physical Education",
    stream: "all",
    category: "sports-edu",
    summary:
      "Generally Open for all Streams, Professional course in physical education, fitness training, sports science, and coaching.",
    eligibility: "10+2 in any stream; minimum 45–50% marks. Some states/institutes require physical fitness test.",
    exams: ["State B.P.Ed Entrance", "NCHPEB Entrance"],
    colleges: [
      "Lakshmibai National Institute of Physical Education (LNIPE), Gwalior",
      "IGNOU – School of Physical Education",
      "Punjab University – Department of Physical Education",
      "Delhi University Colleges with B.P.Ed"
    ],
    source: "Our data, thoughtfully compiled by PrepX Pathshala. Please verify with official sites.",
    keywords: ["sports", "fitness", "coaching", "physical training"],
  },
  {
    id: "bed",
    name: "B.Ed – Bachelor of Education",
    stream: "all",
    category: "sports-edu",
    summary:
      "Generally Open for all Streams, Professional course for teaching in schools; focuses on pedagogy, psychology, and subject specialization.",
    eligibility: "Graduation in any discipline (10+2 + UG); entrance via NCTE or state-level B.Ed entrance exams.",
    exams: ["State B.Ed CETs", "DU B.Ed Entrance", "IPU CET B.Ed"],
    colleges: [
      "Lady Irwin College, Delhi",
      "NCERT / Regional Institutes of Education",
      "Christ University, Bengaluru",
      "Delhi University Colleges offering B.Ed"
    ],
    source: "Our data, thoughtfully compiled by PrepX Pathshala. Please verify with official sites.",
    keywords: ["teaching", "pedagogy", "school education", "curriculum"],
  },
  {
    id: "bfa-sports-science",
    name: "B.Sc / B.P.Ed in Sports Science / Exercise Physiology / Kinesiology",
    stream: "all",
    category: "sports-edu",
    summary:
      "Generally Open for all Streams, Scientific study of human movement, sports performance, nutrition, biomechanics, and health.",
    eligibility: "10+2 in any stream; some institutes prefer Science stream (PCB/PCM).",
    exams: ["State UG Entrance", "Institute-specific exams"],
    colleges: [
      "Lakshmibai National Institute of Physical Education (LNIPE), Gwalior",
      "Jiwaji University, Gwalior",
      "Tamil Nadu Physical Education & Sports University, Chennai"
    ],
    source: "Our data, thoughtfully compiled by PrepX Pathshala. Please verify with official sites.",
    keywords: ["sports science", "exercise physiology", "kinesiology", "fitness"],
  },
  {
    id: "bfa-music-dance",
    name: "B.A. / B.F.A in Music, Dance, Performing Arts",
    stream: "arts",
    category: "sports-edu",
    summary:
      "Creative studies in performing arts including classical & contemporary music, dance, and theatre.",
    eligibility: "10+2 in any stream; entrance via auditions / institute-specific tests.",
    exams: ["State Performing Arts Entrance", "CUET UG", "Institute Auditions"],
    colleges: [
      "Banaras Hindu University – Faculty of Performing Arts",
      "Kalakshetra Foundation, Chennai",
      "Maharaja Sayajirao University, Baroda",
      "Indira Kala Sangeet Vishwavidyalaya, Khairagarh"
    ],
    source: "Our data, thoughtfully compiled by PrepX Pathshala. Please verify with official sites.",
    keywords: ["music", "dance", "theatre", "performing arts"],
  },
  {
    id: "bfa-fine-arts-sports",
    name: "BFA / BVA in Fine Arts / Visual Arts",
    stream: "arts",
    category: "sports-edu",
    summary:
      "Creative and technical study of painting, sculpture, printmaking, applied arts, and visual communication.",
    eligibility: "10+2 in any stream; entrance via NID, NIFT, or institute-specific tests.",
    exams: ["NID Entrance", "UCEED", "State Design Exams", "CUET UG"],
    colleges: [
      "Government College of Arts, Chandigarh",
      "MS University, Baroda – Faculty of Fine Arts",
      "Raja Ravi Varma College of Fine Arts, Kerala",
      "Jamia Millia Islamia, Delhi – Faculty of Fine Arts"
    ],
    source: "Our data, thoughtfully compiled by PrepX Pathshala. Please verify with official sites.",
    keywords: ["painting", "sculpture", "visual arts", "creative arts"],
  },
  {
    id: "dietetics-nutrition",
    name: "B.Sc / B.A. in Dietetics, Nutrition & Health Sciences",
    stream: "science",
    category: "sports-edu",
    summary:
      "Study of human nutrition, diet planning, health, wellness, and public nutrition programs.",
    eligibility: "10+2 with PCB; some institutes accept any stream. Entrance via CUET / institute exams.",
    exams: ["CUET UG", "State UG Entrance", "Institute-specific exams"],
    colleges: [
      "Lady Irwin College, Delhi",
      "Amity University, Noida",
      "Christ University, Bengaluru",
      "IGNOU – Nutrition & Health Sciences"
    ],
    source: "Our data, thoughtfully compiled by PrepX Pathshala. Please verify with official sites.",
    keywords: ["nutrition", "dietetics", "health sciences", "wellness"],
  },
];

export default SPORTS_EDU;
